function SearchPrompt() {
    var seachtext = document.querySelector('#searchText');
    var self = this;
    self.speed = 50;
    self.repeat_delay = 3000;
    self.current_pos = 0;
    self.message = JSON.parse(seachtext.innerHTML);
    self.message_pos = 0;
    self.typewriter_stop = false;
    self.element = '#searchQuery';
    self.search_button = '.search__submit';
    self.placeholder = document.getElementById("searchQuery").getAttribute("placeholder");
    self.main_lang_string = self.placeholder;
    self.search_value = document.getElementById("searchQuery").getAttribute("value");
}
SearchPrompt.prototype.init = function () {
    var self = this;
    var target = $(self.element);
    var search_button = $(self.search_button);
    target.focus(function(){
        if (!self.typewriter_stop) {
            self.typewriter_stop = true;
            var i;
            for (i = 0; i < self.message.length; i++) {
                var replacementValue = self.placeholder;
                if (self.message[i].indexOf(replacementValue) > -1 || (self.main_lang_string.indexOf(replacementValue) > -1 && self.search_value === "")) {
                    $(self.element).val('');
                }
            }
        }
        return false;
    });
    search_button.click(function () {
        if (!self.typewriter_stop) {
            self.typewriter_stop = true;
            var i;
            for (i = 0; i < self.message.length; i++) {
                if (self.message[i].indexOf(self.placeholder) > -1 || (self.main_lang_string.indexOf(self.placeholder) > -1 && self.search_value === "")) {
                    $(self.element).val('');
                }
            }
            $(self.element).focus();
            return false;
        }
    });
    if (target.is(":focus")) {
        self.typewriter_stop = true;
    }
    setTimeout(function () {
        self.typeWriter()
    }, 5000);
}
SearchPrompt.prototype.typeWriter = function () {
    var self = this;
    var target = $(self.element);
    if (typeof window.__sf != 'undefined' && typeof window.__sf.config != 'undefined' && typeof window.__sf.config.search != 'undefined' && typeof window.__sf.config.search.enabled != 'undefined' && window.__sf.config.search.enabled == true) {
        self.typewriter_stop = true;
    }
    if (!self.typewriter_stop) {
        if (self.current_pos == 0) {
            target.val('');
        }
        if (self.current_pos < self.message[self.message_pos].length) {
            target.val(target.val() + self.message[self.message_pos].charAt(self.current_pos));
            self.current_pos++;
            setTimeout(function () {
                self.typeWriter()
            }, self.speed);
        } else {
            self.current_pos = 0;
            if (self.message_pos < self.message.length - 1) {
                self.message_pos++;
            } else {
                self.message_pos = 0;
            }
            setTimeout(function () {
                self.typeWriter()
            }, self.repeat_delay);
        }
    }
}
var search_prompt = new SearchPrompt();
search_prompt.init();